/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';

import {
   KEYBOARD_INTERFACE_TYPE,
   SEQUENCER_INTERFACE_TYPE,
} from './interfaceTypes';
import { KeyboardInterface } from './keyboard/KeyboardInterface';
import { SequencerInterface } from './sequencer/SequencerInterface';

const mapStateToProps = ({ activeInterface }) => ({
   interfaceType: activeInterface?.type,
});

const Interface = connect(mapStateToProps)(({ interfaceType }) => {
   switch (interfaceType) {
      case KEYBOARD_INTERFACE_TYPE:
         return <KeyboardInterface />;
      case SEQUENCER_INTERFACE_TYPE:
         return <SequencerInterface />;
      default:
         return null;
   }
});

export { Interface };
